import { graphQlClient } from '@config/graphqlClient';
import DailySiteReportGraphQL from '@graphql/dailySiteReport.queries';
import {
  DailySiteReport,
  DailySiteReportOrganizationSettingsInput,
  DailySiteReportSettings,
  DailySiteReportSummary,
} from '@models/dailySiteReport.model';

export const getDailySiteReportAvailable = async (): Promise<boolean> => {
  const data: { dailySiteReportAvailable: boolean } = await graphQlClient.request(
    DailySiteReportGraphQL.queries.dailySiteReportAvailable,
  );
  return !!data.dailySiteReportAvailable;
};

export const getDailySiteReportSettings = async (): Promise<DailySiteReportSettings> => {
  const data: { dailySiteReportSettings: DailySiteReportSettings } = await graphQlClient.request(
    DailySiteReportGraphQL.queries.dailySiteReportSettings,
  );
  return data.dailySiteReportSettings;
};

export const getMyDailySiteReports = async (limit: number, offset: number): Promise<DailySiteReportSummary[]> => {
  const data: { myDailySiteReports: DailySiteReportSummary[] } = await graphQlClient.request(
    DailySiteReportGraphQL.queries.myDailySiteReports,
    { limit, offset },
  );
  return data.myDailySiteReports || [];
};

export const getDailySiteReport = async (reportId: string): Promise<DailySiteReport> => {
  const data: { dailySiteReport: DailySiteReport } = await graphQlClient.request(
    DailySiteReportGraphQL.queries.dailySiteReport,
    { reportId },
  );
  return data.dailySiteReport;
};

export const updateDailySiteReportOrganizationSettings = async (
  input: DailySiteReportOrganizationSettingsInput,
): Promise<DailySiteReportSettings> => {
  const data: { updateDailySiteReportOrganizationSettings: DailySiteReportSettings } = await graphQlClient.request(
    DailySiteReportGraphQL.mutations.updateDailySiteReportOrganizationSettings,
    { input },
  );
  return data.updateDailySiteReportOrganizationSettings;
};

export const sendMyDailySiteReportNow = async (): Promise<DailySiteReport> => {
  const data: { sendMyDailySiteReportNow: DailySiteReport } = await graphQlClient.request(
    DailySiteReportGraphQL.mutations.sendMyDailySiteReportNow,
  );
  return data.sendMyDailySiteReportNow;
};

const dailySiteReportService = {
  getDailySiteReportAvailable,
  getDailySiteReportSettings,
  getMyDailySiteReports,
  getDailySiteReport,
  updateDailySiteReportOrganizationSettings,
  sendMyDailySiteReportNow,
};

export default dailySiteReportService;
